import { useState } from "react";
import { Segmented } from "antd";
import { OrderedListOutlined } from "@ant-design/icons";
import { LuShoppingBag } from "react-icons/lu";
import useGet from "../../../global/hooks/useGet";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { DeviceLogItemColumns } from "../Page/DeviceLogItemColumns";
import {
  DeviceOrderItemColumns,
  DeviceOrderItemChildColumns,
} from "../Page/DeviceOrderItemColumns";

/** Logs / Orders tabs shown at the bottom of the device and site info pages. */
export const DeviceLogsOrdersPanel = ({ deviceNo, logsLabel = "Device Logs" }) => {
  const tabs = [
    { label: logsLabel, value: "deviceLog", icon: <OrderedListOutlined /> },
    { label: "Orders", value: "order", icon: <LuShoppingBag /> },
  ];
  const [tabValue, setTabValue] = useState(tabs[0].value);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const logQuery = new URLSearchParams({
    limit: 20,
    sort_by: "LogNo",
    order: "desc",
    DeviceNo: deviceNo,
  }).toString();
  const { data: logData, loading: logLoading } = useGet(
    deviceNo
      ? `${process.env.REACT_APP_API_URL}/api/devicelogs/?${logQuery}`
      : null,
  );
  const { data: orderData, loading: orderLoading } = useGet(
    deviceNo && tabValue === "order"
      ? `${process.env.REACT_APP_API_URL}/api/orders/${deviceNo}/device-orders/`
      : null,
  );
  return (
    <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
      <div className="bg-gray-200">
        <div className="py-[5.748px] px-2.5 custom-segmented">
          <Segmented
            options={tabs}
            size="middle"
            onChange={setTabValue}
            className="!bg-transparent !text-black"
          />
        </div>
        {tabValue === "deviceLog" ? (
          <GlobalTable
            key="deviceLog"
            columns={DeviceLogItemColumns()}
            dataSource={logData?.data?.map((el, index) => ({
              ...el,
              key: el.LogNo ?? index,
            }))}
            loading={logLoading}
          />
        ) : (
          <GlobalTable
            key="order"
            columns={DeviceOrderItemColumns()}
            dataSource={orderData?.data?.map((el) => ({
              ...el,
              key: el.OrderNo,
            }))}
            loading={orderLoading}
            expandable={{
              expandedRowKeys,
              rowExpandable: (record) =>
                Array.isArray(record?.OrderItems) &&
                record.OrderItems.length > 0,
              expandedRowRender: (record) => (
                <div className="pl-8 pr-2 py-1">
                  <GlobalTable
                    columns={DeviceOrderItemChildColumns}
                    dataSource={record.OrderItems.map((item, index) => ({
                      ...item,
                      key: item.ItemNo ?? index,
                    }))}
                    pagination={false}
                    tableProps={{ size: "small" }}
                  />
                </div>
              ),
              onExpand: (expanded, record) =>
                setExpandedRowKeys((prev) =>
                  expanded
                    ? [...prev, record.OrderNo]
                    : prev.filter((k) => k !== record.OrderNo),
                ),
              columnWidth: 40,
            }}
          />
        )}
      </div>
    </div>
  );
};
